import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ForecastPhaseSummaryProps {
  testId?: string;
  className?: string;
  data?: {
    errorRate: string | null | undefined;
    startYm: string | null | undefined;
    endYm: string | null | undefined;
  };
}

export const ForecastPhaseSummary: React.FC<ForecastPhaseSummaryProps> = ({
  testId,
  className,
  data,
}) => {
  const quarterData = useMemo(() => {
    return {
      startDate: `${data?.startYm ?? ''}`,
      endDate: `${data?.endYm ? data.endYm.split('-')[1] : ''}`,
    };
  }, []);
  const { t } = useTranslation();

  return data?.errorRate && data?.endYm && data?.startYm ? (
    <div
      data-testid={testId}
      className={`noto-13-normal flex items-center rounded-[45px] border-[2px] border-light-6 bg-light-1 px-[15px] py-2 text-dark-6 ${className}`}
    >
      <div className="mr-[10px] h-[6px] w-[6px] bg-light-6"></div>
      <span>{t('forecast.prediction', { context: 'summary' })}</span>
      <span>{t('forecast.quarter', quarterData)}</span>
      <span>{` : ${t('forecast.average')} ${t('forecast.percentageError')} ${data.errorRate}`}</span>
    </div>
  ) : (
    <></>
  );
};
